import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  default: {
    passport: false,
    driving_license: false,
    boarding_card: false,
    cruise: false,
    cruise_schedule: false,
    itinerary: false,
    credit_card: false,
    fmm: false,
    entry_stamp: false
  },
  files: [{}],
  paymentCard: [],
  purchaseFiles: {
    pos: [],
    cc_slips: []
  },
  haveArn: false,
  arnUploaded: false,
  all_factura_processed: false
}

export const securelinkSlice = createSlice({
  name: 'securelink',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setSecureLink: (state, action) => {
      state.default = { ...state.default, ...action.payload }
    },
    setSecureLinkFromAPI: (state, action) => {
      const { defaults, files } = action.payload || {}
      if (defaults && typeof defaults === 'object') {
        state.default = { ...state.default, ...defaults }
      }
      if (Array.isArray(files)) {
        state.files = files.length > 0 ? files : [{}]
      }
    },
    addSecureOtherFiles: state => {
      state.files.push({})
    },
    setSecureOtherFiles: (state, action) => {
      const { index, attributes } = action.payload
      state.files[index] = {
        ...state.files[index],
        ...attributes
      }
    },
    setPurchaseFiles: (state, action) => {
      const { attributes: item, file_type } = action.payload
      const fileList = state.purchaseFiles[file_type]
      const existItem = fileList.find(x => x.id === item.id)
      if (existItem) {
        if (file_type === 'pos') {
          existItem.send_pos_secure_link = item.send_pos_secure_link
        } else {
          existItem.send_cc_slip_secure_link = item.send_cc_slip_secure_link
        }
      } else {
        state.purchaseFiles[file_type] = [...fileList, item]
      }
    },
    setPaymentCard: (state, action) => {
      const item = action.payload.attributes
      const existItem = state.paymentCard.find(x => x.id === item.id)
      if (existItem) {
        existItem.send_payment_card_secure_link =
          item.send_payment_card_secure_link
      } else {
        state.paymentCard.push(item)
      }
    },
    removeSecureOtherFiles: (state, action) => {
      const { index } = action.payload
      state.files.splice(index, 1)
    },
    initializeSecurelink: () => initialState,
    setArnModal: (state, action) => {
      const { haveArn } = action.payload
      state.haveArn = haveArn
    },
    setArnUploaded: (state, action) => {
      const { arn } = action.payload
      state.arnUploaded = arn
    },
    setAllFacturaProcessed: (state, action) => {
      const { all_factura_processed } = action.payload
      state.all_factura_processed = all_factura_processed
    }
  }
})

export const {
  setSecureLink,
  setSecureLinkFromAPI,
  initializeSecurelink,
  setPaymentCard,
  addSecureOtherFiles,
  setSecureOtherFiles,
  setPurchaseFiles,
  removeSecureOtherFiles,
  setArnModal,
  setArnUploaded,
  setAllFacturaProcessed
} = securelinkSlice.actions

export default securelinkSlice.reducer
